import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Home",
		children: [/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 5311",
			d: "M3.5,12.5v10h6v-7h5v7h6V13",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			"data-name": "Path 5312",
			d: "M.5,12,12,.5,23.5,12",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	})
});
export { SvgHomeIcon as ReactComponent };
